import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';

import * as actions from '../../../../store/modules/auth/actions';

import { displayErrors } from '../../../../util/diversos';
import { Input100px, Input155px } from '../../../../styles/inputGroup';

import Card from '../../../../components/card';
import store from '../../../../store/store';
import axiosAdmin from '../../../../services/axiosAdmin';
import Loading from '../../../loading';

export default function CadastroEstampariaModelo({ payloadCadastro, childToParentConsulta }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const id = get(payloadCadastro, 'id', 0);

  const [descricao, setDescricao] = useState('');
  const [valorAcrescimo, setValorAcrescimo] = useState(0);

  const [trabalharFonteCaixaAlta, setTrabalharFonteCaixaAlta] = useState(false);

  useEffect(() => {
    async function getConfiguracaoSistema() {
      try {
        setIsLoading(true);

        const idUsuario = get(store.getState().auth.user, 'id', 0);

        const params = `/configuracaosistema?idUsuario=${idUsuario}`;

        const response = await axiosAdmin.get(params);

        setTrabalharFonteCaixaAlta(get(response.data, 'trabalharFonteCaixaAlta', false));
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getConfiguracaoSistema();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let newTitle = 'Modelo (Estamparia) - Cadastro';
    if (id) {
      newTitle = 'Modelo (Estamparia) - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/estampariamodelo/${id}`);

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          navigate('/consultaestampariamodelo');
          toast.error('Acesso negado');
        }

        setDescricao(data.descricao);
        setValorAcrescimo(data.valorAcrescimo);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, navigate]);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let payloadDataTableList = {};

      const shippingData = {
        idUsuario,
        descricao: trabalharFonteCaixaAlta ? descricao.toUpperCase() : descricao,
        valorAcrescimo,
      };

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/estampariamodelo/${id}`, shippingData), 'data', {});
        toast.success('Modelo (Estamparia) atualizado com sucesso');
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/estampariamodelo', shippingData), 'data', {});
        toast.success('Modelo (Estamparia) cadastrado com sucesso');
      }

      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    childToParentConsulta();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (!descricao) {
      formErros = true;
      toast.error('Descrição deve ser informada');
    }
    if (valorAcrescimo < 0) {
      formErros = true;
      toast.error('Valor de acréscimo não pode ser negativo');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const titulo = () => (id ? 'Modelo (Estamparia) - Alteração' : 'Modelo (Estamparia) - Inclusão');

  function botoesFinalizar() {
    return (
      <div className="card-header" style={{ marginLeft: '12px', marginRight: '12px', width: '98%' }}>
        <div className="row">
          <div className="col-lg-9">
            <div style={{ display: 'flex', justifyContent: 'start', position: 'relative', top: '20%' }}>
              <h6>{titulo()}</h6>
            </div>
          </div>
          <div className="col-lg-3">
            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-success"
              >
                <i className="pi pi-check"></i>
                Salvar
              </button>
              <button
                onClick={handleCancel}
                type="button"
                className="btn btn-danger"
              >
                <i className="pi pi-times"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card style={{ marginTop: '16px' }}>
        <div className="row form-elo">
          { botoesFinalizar() }
        </div>
        <div className="row form-elo">
          <div className="col-8">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Descrição
              </Input100px>
              <InputText
                autoFocus
                maxLength={20}
                value={descricao}
                onChange={e => setDescricao(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Valor Acréscimo
              </Input155px>
              <InputNumber
                mode="currency"
                inputId="currency-br"
                currency="BRL"
                locale="pt-BR"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={valorAcrescimo}
                onValueChange={e => setValorAcrescimo(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
